import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-personal-information',
  templateUrl: './app-personal-information.component.html'
})
export class AppPersonalInformationComponent {


  /**
   * The formData that is being passed between each sub-component which
   * will eventually be posted to the remote service.
   */
  @Input()
  formData: any;

}



// WEBPACK FOOTER //
// /home/runner/work/debtpanel-portal/debtpanel-portal/webforms/legal-aid/src/app/personal-information/app-personal-information.component.ts